export const createPaymentRequestCode = {
    "curl": {
      "request": `curl -X 'POST'
'https://demo-api.westpay.se/in-store/api/v1/purchase'
-H 'accept: text/plain'
-H 'Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04'
-H 'Ocp-Apim-Subscription-Key: 76591d32138f4f60b580db9ec9167f1d'
-H 'Content-Type: application/json'
-d '{
    "amount": 380.75,
    "currencyCode": 752,
    "terminalId": "80000782",
    "paymentMethod": "Swish"
}'`
    },
    "java": {
      "request": `import com.google.gson.Gson;
import com.google.gson.GsonBuilder;

import java.io.BufferedReader;
import java.io.DataOutputStream;
import java.io.IOException;
import java.io.InputStreamReader;
import java.net.HttpURLConnection;
import java.net.URL;

public class APICallExample {
    public static void main(String[] args) {
        try {
            // API endpoint URL
            URL url = new URL("https://demo-api.westpay.se/in-store/api/v1/purchase");

            // Create HttpURLConnection
            HttpURLConnection connection = (HttpURLConnection) url.openConnection();
            connection.setRequestMethod("POST");

            // Set request headers
            connection.setRequestProperty("accept", "text/plain");
            connection.setRequestProperty("Ocp-Apim-Subscription-Key", "76591d32138f4f60b580db9ec9167f1d");
            connection.setRequestProperty("Authorization", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04");
            connection.setRequestProperty("Content-Type", "application/json");

            // Enable input and output streams
            connection.setDoOutput(true);
            connection.setDoInput(true);

            // Create request body object
            PurchaseRequest requestBody = new PurchaseRequest();
            requestBody.setAmount(380.75);
            requestBody.setCurrencyCode(752);
            requestBody.setTerminalId("80000782");
            requestBody.setPaymentMethod("Swish");

            // Convert request body object to JSON
            Gson gson = new GsonBuilder().create();
            String jsonBody = gson.toJson(requestBody);

            // Send request
            DataOutputStream outputStream = new DataOutputStream(connection.getOutputStream());
            outputStream.writeBytes(jsonBody);
            outputStream.flush();
            outputStream.close();

            // Get response
            int responseCode = connection.getResponseCode();
            BufferedReader reader;
            if (responseCode >= 200 && responseCode < 300) {
                reader = new BufferedReader(new InputStreamReader(connection.getInputStream()));
            } else {
                reader = new BufferedReader(new InputStreamReader(connection.getErrorStream()));
            }

            String line;
            StringBuilder response = new StringBuilder();
            while ((line = reader.readLine()) != null) {
                response.append(line);
            }
            reader.close();

            // Print response
            System.out.println("Response Code: " + responseCode);
            System.out.println("Response Body: " + response.toString());

            // Close connection
            connection.disconnect();

        } catch (IOException e) {
            e.printStackTrace();
        }
    }

    static class PurchaseRequest {
        private double amount;
        private int currencyCode;
        private String terminalId;
        private String paymentMethod;

        public double getAmount() {
            return amount;
        }

        public void setAmount(double amount) {
            this.amount = amount;
        }

        public int getCurrencyCode() {
            return currencyCode;
        }

        public void setCurrencyCode(int currencyCode) {
            this
        }
    }
}`
    },
    "C#": {
      "request": `using System;
using System.IO;
using System.Net;
using System.Text;
      
namespace APICallExample
{
    class Program
    {
        static void Main(string[] args)
        {
            try
            {
                // API endpoint URL
                string url = "https://demo-api.westpay.se/in-store/api/v1/purchase";
      
                // Create WebRequest
                HttpWebRequest request = (HttpWebRequest)WebRequest.Create(url);
                request.Method = "POST";
      
                // Set request headers
                request.Accept = "text/plain";
                request.Headers.Add("Authorization", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04");
                request.Headers.Add("Ocp-Apim-Subscription-Key", "76591d32138f4f60b580db9ec9167f1d");
                request.ContentType = "application/json";
      
                // Create request body object
                var requestBody = new
                {
                    amount = 380.75,
                    currencyCode = 752,
                    terminalId = "80000782",
                    paymentMethod = "Swish"
                };
      
                // Convert request body object to JSON
                string jsonBody = Newtonsoft.Json.JsonConvert.SerializeObject(requestBody);
      
                // Convert JSON to byte array
                byte[] byteData = Encoding.UTF8.GetBytes(jsonBody);
      
                // Set content length
                request.ContentLength = byteData.Length;
      
                // Write request body
                using (Stream requestStream = request.GetRequestStream())
                {
                    requestStream.Write(byteData, 0, byteData.Length);
                }
      
                // Get response
                using (HttpWebResponse response = (HttpWebResponse)request.GetResponse())
                using (StreamReader reader = new StreamReader(response.GetResponseStream()))
                {
                    string responseBody = reader.ReadToEnd();
      
                    // Print response
                    Console.WriteLine("Response Code: " + (int)response.StatusCode);
                    Console.WriteLine("Response Body: " + responseBody);
                }
            }
            catch (Exception ex)
            {
                Console.WriteLine(ex.ToString());
            }
        }
    }
}`
    },
    "python": {
      "request": `import json
import requests
      
# API endpoint URL
url = 'https://demo-api.westpay.se/in-store/api/v1/purchase'
      
# Request headers
headers = {
    'accept': 'text/plain',
    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04',
    'Ocp-Apim-Subscription-Key': '76591d32138f4f60b580db9ec9167f1d',
    'Content-Type': 'application/json'
}
      
# Request body
request_body = {
    'amount': 380.75,
    'currencyCode': 752,
    'terminalId': '80000782',
    'paymentMethod': 'Swish'
}
      
# Convert request body to JSON
json_body = json.dumps(request_body)
      
# Make the API call
response = requests.post(url, headers=headers, data=json_body)
      
# Get response code and body
response_code = response.status_code
response_body = response.text
      
# Print response
print('Response Code:', response_code)
print('Response Body:', response_body)`
    },
    
    "JavaScript": {
      "request": `const fetch = require('node-fetch');

// API endpoint URL
const url = 'https://demo-api.westpay.se/in-store/api/v1/purchase';
      
// Request headers
const headers = {
    'accept': 'text/plain',
    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04',
    'Ocp-Apim-Subscription-Key': '76591d32138f4f60b580db9ec9167f1d',
    'Content-Type': 'application/json'
};
      
// Request body
const requestBody = {
    amount: 380.75,
    currencyCode: 752,
    terminalId: '80000782',
    paymentMethod: 'Swish'
};
      
// Make the API call
fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(requestBody)
})
.then(response => {
    // Get response code and body
    const responseCode = response.status;
    return response.text().then(responseBody => {
        // Print response
        console.log('Response Code:', responseCode);
        console.log('Response Body:', responseBody);
    });
})
.catch(error => {
    console.error('Error:', error);
});`
    }
  };
 
  export const createPaymentRequestCodeResponse = `{
    "onlineAPIRefId": "23179040000954"
}`;  

  